import {combineReducers} from 'redux';
import {routerReducer} from 'react-router-redux';
import Faq from './Faq';
import Settings from './Settings';
import Profile from './Profile';
import Api from './Api';
import Invoices from './Invoices';
import Services from './Services';
import Result from './Result';

const reducers = combineReducers({
    api: Api,
    faq: Faq,
    invoices: Invoices,
    profile: Profile,
    routing: routerReducer,
    services: Services,
    settings: Settings,
    result: Result,
});

export default reducers;
